"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowCareTeamsBelowAltProviders = exports.shouldShowCareTeams = exports.isCareTeamsForStep2Enabled = exports.shouldShowAlternativeProviders = void 0;
const States_1 = require("../../lib/constants/States");
/**
 * Determines if the alternative providers should be shown step 2
 */
function shouldShowAlternativeProviders({ currentState, config, featureFlags }) {
    return (currentState.matches(States_1.apptTime) &&
        ((config === null || config === void 0 ? void 0 : config.show_dbw_appt_time_alt_providers) ||
            (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.dbw_suggest_alt_providers_for_step_2)));
}
exports.shouldShowAlternativeProviders = shouldShowAlternativeProviders;
/**
 * Checks if Care Teams should be shown in step 2
 *
 * Expects the following feature flags:
 *
 * feature_flags: {
 *  provider_profile_care_team: boolean,
 *  dbw_suggest_care_teams_for_step_2_below_alt_provider: boolean
 * }
 *
 * @param {Object} featureFlags - The feature flags object
 * @returns {boolean} - true if care teams should be shown
 */
function isCareTeamsForStep2Enabled(featureFlags) {
    return (
    // Show if care teams feature is enabled
    (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.provider_profile_care_team) &&
        (
        // && Show if care teams suggestions are enabled for step 2
        featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.dbw_suggest_care_teams_for_step_2));
}
exports.isCareTeamsForStep2Enabled = isCareTeamsForStep2Enabled;
/**
 * Determines if the care teams should be shown in step 2
 *
 * Expects the following feature flags:
 *
 * feature_flags: {
 *  provider_profile_care_team: boolean,
 *  dbw_suggest_care_teams_for_step_2: boolean,
 *  dbw_suggest_care_teams_for_step_2_below_alt_provider: boolean
 * }
 *
 * @param {Object} params - The parameters object
 * @param {Object} params.currentState - The current state of the service
 * @param {Object} params.featureFlags - The feature flags object
 *
 * @returns {boolean} - true if care teams should be shown
 */
function shouldShowCareTeams({ currentState, featureFlags }) {
    return (currentState.matches(States_1.apptTime) && isCareTeamsForStep2Enabled(featureFlags));
}
exports.shouldShowCareTeams = shouldShowCareTeams;
/**
 * Checks if Care Teams should be displayed below Alternative Providers in Step 2
 * @param {object} featureFlags
 * @returns {boolean}
 */
function shouldShowCareTeamsBelowAltProviders(featureFlags) {
    return featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.dbw_suggest_care_teams_for_step_2_below_alt_provider;
}
exports.shouldShowCareTeamsBelowAltProviders = shouldShowCareTeamsBelowAltProviders;
//# sourceMappingURL=utils.directBook.js.map